var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.atSelectImportSource
        ? _c("SelectImportSourceModal", {
            attrs: { manageMode: _vm.manageMode },
            on: { submit: _vm.nextState, cancel: _vm.emitCancel },
          })
        : _vm._e(),
      _vm.atSelectDrive
        ? _c("SelectDriveModal", {
            attrs: { manageMode: _vm.manageMode },
            on: { submit: _vm.nextState, cancel: _vm.emitCancel },
          })
        : _vm._e(),
      _vm.atSelectNetworkAddress
        ? _c("SelectNetworkDeviceModal", {
            attrs: { manageMode: _vm.manageMode },
            on: { submit: _vm.nextState, cancel: _vm.emitCancel },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }